import React, { useState, useEffect } from "react";
import {
  Card,
  Tag,
  Typography,
  Button,
  Space,
  Row,
  Col,
  Divider,
  message,
} from "antd";
import {
  CheckCircleTwoTone,
  ExclamationCircleTwoTone,
  CloseCircleTwoTone,
  FilePdfOutlined,
} from "@ant-design/icons";
import ValuesStore from "../../store/values-store";
import CustomFunctions from "../../dependencies/custom/custom-functions";
import { useNavigate } from "react-router-dom";

const { Title, Text } = Typography;

const ApplicantDashboard = () => {
  const valuesStore = ValuesStore();
  const navigate = useNavigate();
  const [admissionID, setAdmissionID] = useState();
  const [applicant, setApplicant] = useState();

  useEffect(() => {
    const admID = JSON.parse(
      sessionStorage.getItem("user") || "{}",
    )?.admissionID;
    setAdmissionID(admID);
    bootstrap(admID);
  }, [applicant]);

  async function bootstrap(admissionID) {
    let { data, dataInGroups } = await CustomFunctions.getDataFromDB(
      admissionID,
      navigate,
    );
    // console.log(data)
    data["paymentStatus"] = parseInt(data["hasPaid"]) ? "paid" : "pending";
    data["boardingStatus"] =
      data["dayBoarding"] == "day"
        ? data["dayBoarding"]
        : `Boarding (Awaiting Confirmation)`;
    data["dateApplied"] = "2025-09-18";
    // console.log(data)
    if (!applicant) setApplicant(data);
  }

  // Paystack payment handler (mock)
  const handlePayment = () => {
    message.loading("Redirecting to Paystack...", 1.5);
    setTimeout(() => {
      message.success("Payment successful (mock)");
      setApplicant({ ...applicant, paymentStatus: "paid" });
    }, 2000);
  };

  const handlePrintLetter = () => {
    message.success("Printing Admission Letter...");
  };

  return (
    <div>
      <Card
        bordered={false}
        style={{ marginBottom: 30 }}
        className="rounded-2xl shadow"
      >
        <Space direction="vertical" style={{ width: "100%" }}>
          <Title level={3} style={{ marginBottom: 0 }}>
            Welcome back, {applicant?.firstName} 👋
          </Title>
          <Text type="secondary">Class Applied: {applicant?.classApplied}</Text>
        </Space>
      </Card>

      {/* Information Sections */}
      <Row gutter={[24, 24]}>
        {/* Admission Status */}
        <Col xs={24} md={12} lg={8}>
          <Card
            title="Admission Status"
            bordered
            className="rounded-2xl shadow"
          >
            <Space direction="vertical" size="middle">
              {applicant?.admission_status === "admitted" && (
                <Tag
                  icon={<CheckCircleTwoTone twoToneColor="#52c41a" />}
                  color="success"
                >
                  ADMITTED
                </Tag>
              )}
              {["pending", "draft"].includes(
                applicant?.admission_status?.toLowerCase(),
              ) && (
                <Tag
                  icon={<ExclamationCircleTwoTone twoToneColor="#faad14" />}
                  color="warning"
                >
                  PENDING
                </Tag>
              )}
              {applicant?.admission_status === "rejected" && (
                <Tag
                  icon={<CloseCircleTwoTone twoToneColor="#f5222d" />}
                  color="error"
                >
                  NOT ADMITTED
                </Tag>
              )}

              <Text>
                {applicant?.admission_status === "admitted"
                  ? "Congratulations! You’ve been offered admission"
                  : ["pending", "draft"].includes(
                        applicant?.admission_status?.toLowerCase(),
                      )
                    ? "Your application is currently under review."
                    : "We regret to inform you that your application was not successful."}
              </Text>
            </Space>
          </Card>
        </Col>

        {/* Admission Fees */}
        <Col xs={24} md={12} lg={8}>
          <Card title="Admission Fees" className="rounded-2xl shadow" bordered>
            <Space direction="vertical" size="middle">
              <Text strong>Total Fee: UGX{applicant?.amount || 0}</Text>
              <Text>
                Status:{" "}
                <Tag
                  color={
                    applicant?.paymentStatus === "paid" ? "green" : "volcano"
                  }
                >
                  {applicant?.paymentStatus?.toUpperCase()}
                </Tag>
              </Text>
              {applicant?.paymentStatus !== "paid" && (
                <Button type="primary" onClick={handlePayment}>
                  Pay with Paystack
                </Button>
              )}
            </Space>
          </Card>
        </Col>

        {/* Boarding Status */}
        <Col xs={24} md={12} lg={8}>
          <Card title="Boarding Status" className="rounded-2xl shadow" bordered>
            <Space direction="vertical">
              <Text>{applicant?.boardingStatus}</Text>
              {/* {applicant?.boardingStatus === "Awaiting allocation" ? (
                                <Tag color="gold">Pending</Tag>
                            ) : (
                                <Tag color="green">Allocated</Tag>
                            )} */}
            </Space>
          </Card>
        </Col>

        {/* Admission Letter */}
        <Col xs={24} md={12} lg={8}>
          <Card
            title="Admission Letter"
            className="rounded-2xl shadow"
            bordered
          >
            <Text>
              {applicant?.admissionStatus === "admitted"
                ? "Your admission letter is ready for printing."
                : "Admission letter will be available after admission is confirmed."}
            </Text>
            <br />
            <Button
              type="default"
              icon={<FilePdfOutlined />}
              style={{ marginTop: 10 }}
              disabled={applicant?.admissionStatus !== "admitted"}
              onClick={handlePrintLetter}
            >
              Print / Download Letter
            </Button>
          </Card>
        </Col>

        {/* Application Summary */}
        <Col xs={24} md={12} lg={8}>
          <Card
            title="Application Summary"
            className="rounded-2xl shadow"
            bordered
          >
            <Space direction="vertical">
              <Text>
                <strong>Application Code:</strong> {applicant?.application_code}
              </Text>
              <Text>
                <strong>Email:</strong> {applicant?.email}
              </Text>
              <Text>
                <strong>Programme:</strong> {applicant?.program}
              </Text>
              <Text>
                <strong>Date Applied:</strong>{" "}
                {new Date(applicant?.dateApplied).toLocaleDateString()}
              </Text>
            </Space>
          </Card>
        </Col>

        <Col xs={24} md={12} lg={8}>
          <Card title="Interview Score" className="rounded-2xl shadow" bordered>
            <Space direction="vertical">
              <Text>
                <strong>English:</strong> {50}
              </Text>
              <Text>
                <strong>Maths:</strong> {50}
              </Text>
            </Space>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default ApplicantDashboard;
